import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffPayments = () => import('./staff/payments')

Vue.use(Router)

const router =
  [
    {
      path: '/st/payments-erp',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: 'PaymentsErpStaffDashboard',
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
        },
        {
          path: 'payments',
          name: 'PaymentsErpStaffPayments',
          component: ViewStaffPayments,
          beforeEnter: Permisos.IS_PERSONAL,
        },
      ]
    },

    {
      path: '/cu/payments-erp',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/payments-erp',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
